/** Typography tokens — text-base first; step down only to text-sm; step up for heroes */

export const USERS_TITLE_CLS = "m-0 text-base font-medium text-foreground";
export const USERS_SUBTITLE_CLS = "m-0 text-sm text-muted-foreground";
export const USERS_SECTION_CLS = "m-0 text-sm font-medium text-muted-foreground";
export const USERS_META_CLS = "m-0 text-sm font-normal leading-snug tabular-nums";
export const USERS_INPUT_CLS = "text-base";
export const USERS_HELPER_CLS = "m-0 text-sm text-muted-foreground";
export const USERS_EMPTY_CLS = "m-0 text-sm text-muted-foreground";
export const USERS_HERO_NAME_CLS =
  "text-lg font-medium text-foreground tracking-tight leading-none";
export const USERS_HERO_METRIC_CLS =
  "text-xl leading-none font-normal tracking-tight tabular-nums";
export const USERS_CHIP_CLS = "text-sm font-medium";
export const USERS_TAB_CLS = "text-base font-normal";
